<ng-container *ngIf="media">
  <ng-container [ngSwitch]="media.type">
    <x-youtube-player
      *ngSwitchCase="'youtube'"
      [url]="media.url"
      [width]="width"
      (mediaLoaded)="onMediaLoaded()"
    ></x-youtube-player>

    <x-vimeo-player
      *ngSwitchCase="'vimeo'"
      [url]="media.url"
      [width]="width"
      (mediaLoaded)="onMediaLoaded()"
    ></x-vimeo-player>

    <x-html5-player
      #HTML5_PLAYER
      *ngSwitchCase="'video'"
      [url]="media.url"
      [width]="width"
      [height]="height"
      [autoplay]="videoAutoplay"
      [controls]="controls"
      (mediaLoaded)="onMediaLoaded()"
      [responsiveConfig]="responsiveConfig"
    ></x-html5-player>

    <x-media-thumbnail
      *ngSwitchDefault
      [url]="media.url"
      [type]="media.type"
      [width]="width"
      [height]="height"
      [loader]="false"
      (mediaLoaded)="onMediaLoaded()"
      [responsiveConfig]="responsiveConfig"
    ></x-media-thumbnail>
    <x-loader *ngIf="loading$ | async" [blurHash]="blurHash"></x-loader>
  </ng-container>
</ng-container>
